import React, { useState } from 'react';
import { getAboutImageUrl } from '../../utils/aboutLayoutDefaults';

/**
 * Ảnh trong layout giới thiệu — luôn nằm trong khung, không tràn màn hình.
 */
const AboutImage = ({ src, fallback, alt, className = '', variant = 'cover' }) => {
    const [failed, setFailed] = useState(false);
    const url = failed ? getAboutImageUrl('', fallback) : getAboutImageUrl(src, fallback);

    const variantClass =
        variant === 'icon'
            ? 'about-img about-img-icon'
            : variant === 'banner'
                ? 'about-img about-img-banner'
                : 'about-img about-img-cover';

    return (
        <img
            src={url}
            alt={alt || ''}
            className={`${variantClass} ${className}`.trim()}
            loading="lazy"
            onError={() => {
                if (!failed) setFailed(true);
            }}
        />
    );
};

export default AboutImage;
